"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var More = function More(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.509 6.668a2.044 2.044 0 100-4.088 2.044 2.044 0 000 4.088zM7.509 11.92a2.044 2.044 0 100-4.088 2.044 2.044 0 000 4.088zM7.509 17.272a2.044 2.044 0 100-4.088 2.044 2.044 0 000 4.088zM12.493 6.668a2.044 2.044 0 100-4.088 2.044 2.044 0 000 4.088zM12.493 11.92a2.044 2.044 0 100-4.088 2.044 2.044 0 000 4.088zM12.493 17.272a2.044 2.044 0 100-4.088 2.044 2.044 0 000 4.088z",
    fill: color
  }));
};
var _default = exports["default"] = More;